import { CookieService } from 'ngx-cookie-service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared-menu-lateral',
  templateUrl: './shared-menu-lateral.component.html'
})
export class SharedMenuLateralComponent implements OnInit {

  idUsuario: number;

  constructor(private cookieService: CookieService) { }

  ngOnInit() {
    this.idUsuario = this.getIdUsuarioLogado();
  }

  logout(): void {
    this.cookieService.deleteAll();
  }

  getIdUsuarioLogado(): number {
    return +this.cookieService.get('siriema.id');
  }

}
